const CompareModels = () => {
  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Compare <span className="text-primary">Robot Models</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Find the perfect automation solution for your business needs.
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-[hsl(var(--line))]">
              <th className="text-left p-4 font-orbitron font-bold">Feature</th>
              <th className="text-center p-4 font-orbitron font-bold">BellaBot Pro</th>
              <th className="text-center p-4 font-orbitron font-bold">KettyBot Pro</th>
              <th className="text-center p-4 font-orbitron font-bold">CC1 Pro</th>
              <th className="text-center p-4 font-orbitron font-bold">PUDU T600</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Primary Use</td>
              <td className="p-4 text-center text-sm">Delivery & Bussing</td>
              <td className="p-4 text-center text-sm">Marketing & Hosting</td>
              <td className="p-4 text-center text-sm">Floor Cleaning</td>
              <td className="p-4 text-center text-sm">Industrial Delivery</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Best For</td>
              <td className="p-4 text-center text-sm">Restaurants</td>
              <td className="p-4 text-center text-sm">Hotels & Retail</td>
              <td className="p-4 text-center text-sm">All Industries</td>
              <td className="p-4 text-center text-sm">Warehouses & Factories</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Load Capacity</td>
              <td className="p-4 text-center text-sm">10kg per tray</td>
              <td className="p-4 text-center text-sm">20kg</td>
              <td className="p-4 text-center text-sm">N/A</td>
              <td className="p-4 text-center text-sm">600kg</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Battery Life</td>
              <td className="p-4 text-center text-sm">8-10 hours</td>
              <td className="p-4 text-center text-sm">8-10 hours</td>
              <td className="p-4 text-center text-sm">6-8 hours</td>
              <td className="p-4 text-center text-sm">12 hours</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Interactive Display</td>
              <td className="p-4 text-center text-sm">✅ Yes</td>
              <td className="p-4 text-center text-sm">✅ Large Screen</td>
              <td className="p-4 text-center text-sm">❌ No</td>
              <td className="p-4 text-center text-sm">✅ Touch Screen</td>
            </tr>
            <tr className="hover:bg-white/5">
              <td className="p-4 font-semibold">Labor Savings</td>
              <td className="p-4 text-center text-sm text-primary font-bold">1-1.5 staff</td>
              <td className="p-4 text-center text-sm text-primary font-bold">1 staff</td>
              <td className="p-4 text-center text-sm text-primary font-bold">1.5-2 staff</td>
              <td className="p-4 text-center text-sm text-primary font-bold">2 staff</td>
            </tr>
            <tr className="hover:bg-white/5">
              <td className="p-4 font-semibold">Annual Savings</td>
              <td className="p-4 text-center text-sm text-primary font-bold">$36,000/yr</td>
              <td className="p-4 text-center text-sm text-primary font-bold">$31,200/yr</td>
              <td className="p-4 text-center text-sm text-primary font-bold">$46,800/yr</td>
              <td className="p-4 text-center text-sm text-primary font-bold">$41,600/yr</td>
            </tr>
            <tr className="hover:bg-white/5">
              <td className="p-4 font-semibold">ROI (Year 1)</td>
              <td className="p-4 text-center text-sm text-primary font-bold">230%</td>
              <td className="p-4 text-center text-sm text-primary font-bold">214%</td>
              <td className="p-4 text-center text-sm text-primary font-bold">240%</td>
              <td className="p-4 text-center text-sm text-primary font-bold">250%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-center mt-8">
        <p className="text-sm text-muted-foreground mb-4">
          *ROI based on average labor costs. Financing options available. Contact us for detailed pricing.
        </p>
      </div>
    </section>
  );
};

export default CompareModels;
